<template>
  <ion-page>
    <ion-content class="welcome-content">
      <div class="background-scene">
        <div class="stars"></div>
        <div class="mountains"></div>
      </div>

      <div class="create-scenario-page-container">
        <div class="glass-card create-scenario-card">
          <div class="create-scenario-page-header">
            <h1 class="create-scenario-page-title">Create New Scenario</h1>
          </div>

          <form @submit.prevent="saveScenario" class="create-scenario-form">
            <div class="create-scenario-input-group">
              <ion-label>Scenario Name</ion-label>
              <input 
                type="text" 
                v-model="newScenario.name" 
                placeholder="Enter scenario name"
                required
                class="create-scenario-custom-input"
              />
            </div>

            <div class="create-scenario-input-group">
              <ion-label>Description (Optional)</ion-label>
              <input 
                type="text" 
                v-model="newScenario.description" 
                placeholder="Enter description"
                class="create-scenario-custom-input"
              />
            </div>

            <div class="create-scenario-form-actions">
              <ion-button fill="outline" class="create-scenario-cancel-button" @click="goBack">
                Cancel
              </ion-button>
              <ion-button expand="block" type="submit" class="create-scenario-create-button">
                Create Scenario
              </ion-button>
            </div>
          </form>
        </div>
      </div>
    </ion-content>
  </ion-page>
</template>

<script>
import { IonPage, IonContent, IonButton, IonLabel, IonInput, IonIcon } from '@ionic/vue';

import { useScenariosStore } from '@/store/scenarios';

export default {
  name: 'CreateScenarioPage',
  components: {
    IonPage, IonContent, IonButton, IonLabel, IonInput, IonIcon
  },

  setup() {
    const scenariosStore = useScenariosStore();
    return { scenariosStore };
  },

  data() {
    return {
      newScenario: {
        name: '',
        description: ''
      }
    }
  },

  computed: {
    profileID() {
      return this.$route.query.profileID || localStorage.getItem('userID');
    }
  },

  mounted() {
    // Set the profile in the scenarios store
    if (this.profileID) {
      this.scenariosStore.setProfile({ id: this.profileID });
    }
  },

  methods: {
    goBack() {
      this.$router.go(-1);
    },

    async saveScenario() {
      try {
        if (!this.profileID) {
          console.error('=== SCENARIO CREATION FAILURE ===');
          console.error('No profile ID available for scenario creation');
          return;
        }
        
        console.log('=== SCENARIO CREATION ATTEMPT ===');
        console.log('Creating scenario with data:', {
          profileID: this.profileID,
          scenarioName: this.newScenario.name,
          scenarioDescription: this.newScenario.description || 'No description provided',
          isDefault: false,
          timestamp: new Date().toISOString()
        });
        
        await this.scenariosStore.createScenario(
          this.newScenario.name,
          this.newScenario.description,
          false // is_default parameter
        );
        
        console.log('=== SCENARIO CREATION SUCCESS ===');
        console.log('Successfully created scenario:', {
          profileID: this.profileID,
          scenarioName: this.newScenario.name,
          scenarioDescription: this.newScenario.description || 'No description provided',
          isDefault: false,
          timestamp: new Date().toISOString()
        });
        
        // Navigate back to the calendar page with a flag indicating scenario creation
        console.log('=== NAVIGATING BACK TO CALENDAR ===');
        console.log('Navigating to calendar with query:', { 
          profileID: this.profileID,
          from: 'create-scenario',
          scenarioName: this.newScenario.name
        });
        
        this.$router.push({
          path: '/calendar',
          query: { 
            profileID: this.profileID,
            from: 'create-scenario',
            scenarioName: this.newScenario.name
          }
        });
        
        console.log('=== NAVIGATION INITIATED ===');
      } catch (error) {
        console.error('=== SCENARIO CREATION FAILURE ===');
        console.error('Failed to create scenario:', {
          profileID: this.profileID,
          scenarioName: this.newScenario.name,
          scenarioDescription: this.newScenario.description || 'No description provided',
          isDefault: false,
          error: error.message,
          timestamp: new Date().toISOString()
        });
        console.error('Full error details:', error);
      }
    }
  }
}
</script>
